import React from 'react';
import {
  Grid,
  GridSize,
  Typography,
  TypographyVariant,
} from '@material-ui/core';
import PostItem from './PostItem';

export interface Props {
  posts: Post[];
  column: number;
  hideDetail?: boolean;
  dateOnly?: boolean;
  imageHeight?: number;
  sideBySide?: boolean;
  titleSize?: TypographyVariant;
  icon?: React.ReactNode;
  type: postTypes;
  onClickVideo?: (url: string) => void;
  loading: boolean;
}

const PostList: React.FC<Props> = ({
  posts,
  column,
  hideDetail,
  dateOnly,
  imageHeight,
  sideBySide,
  titleSize,
  icon,
  type,
  onClickVideo,
  loading,
}) => {
  return (
    <Grid container spacing={1}>
      {posts.length > 0 || loading ? (
        posts.map((post, index) => {
          return (
            <Grid key={index} item xs={12} md={(12 / column) as GridSize}>
              <PostItem
                post={post}
                hideDetail={hideDetail}
                dateOnly={dateOnly}
                imageHeight={imageHeight}
                sideBySide={sideBySide}
                titleSize={titleSize}
                icon={icon}
                type={type}
                onClickVideo={onClickVideo}
              />
            </Grid>
          );
        })
      ) : (
        <Grid
          item
          xs={12}
          style={{
            display: 'flex',
            justifyContent: 'center',
            height: '150px',
            alignItems: 'center',
          }}
        >
          <Typography
            variant="h5"
            color={type === 'video' ? undefined : 'textSecondary'}
          >
            ไม่พบผลลัพธ์
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};

export default PostList;
